import { Route } from '@angular/router';
import { UserPermission } from '@elio/emanager-front/auth/model';
import { BaseRouterStoreState, RouterReducerState } from '@ngrx/router-store';
import { RouteStaticParam } from './route.model';
import { Path, PathRouter, StaticPathRouter } from './typed-router.model';

export interface NavigationBreadcrumb {
  label: string;
  routerLink: StaticPathRouter[];
  labelParamKey?: string;
}

export interface NavigationBreadcrumbComputed {
  label: string;
  routerLink: PathRouter[];
  labelParam?: Record<string, unknown>;
}

export interface CustomRouterState extends BaseRouterStoreState {
  navigationBreadcrumbs: NavigationBreadcrumb[];
  routeParams: Record<RouteStaticParam, unknown>;
  queryParams: Record<string, unknown>;
}

export type NavigationRouterReducerState = RouterReducerState<CustomRouterState>;

export interface CustomRoute extends Omit<Route, 'path' | 'children'> {
  path?: Path;
  children?: CustomRoute[];
  data?: {
    permissions?: UserPermission[];
    breadcrumb?: NavigationBreadcrumb;
    preload?: boolean;
    animation?: string;
    reuse?: boolean;
  };
}
